import * as jsxRuntime from "/home/runner/work/lureo-frontend/lureo-frontend/source/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment